import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Reduz padding/largura para conteúdos compactos. */
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASSES: Record<NonNullable<ContainerProps['size']>, string> = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-[1240px]',
};

export function Container({ size = 'lg', className, children, ...rest }: ContainerProps) {
  return (
    <div
      className={cn('mx-auto w-full px-5 md:px-8 xl:px-12', SIZE_CLASSES[size], className)}
      {...rest}
    >
      {children}
    </div>
  );
}
